import { Link } from "react-router-dom";
import "../Css/home.css";
export default function Study({Cname , yearTime , para, links}) {
  return (
    <div className="Study">
      <div className="top-content">
        <div className="text-content">
          <Link to={links}><h5>{Cname}</h5>
          <p className="yearTime">{yearTime}</p>
          </Link>
        </div>
      </div>
      <p className="para">{para}</p>
    </div>
  );
};
